import { OktaAuth } from "@okta/okta-auth-js";
import { CONFIG } from "@lib/config";

// Inside the Storyblok Visual Editor the app runs as a partitioned third-party iframe where
// Okta's silent renew (a hidden iframe to Okta) is blocked the same way the login page is.
// Disable auto-renew there to avoid futile renew attempts and console noise — the editor
// re-prompts via the popup login on expiry instead. Normal app windows (and the login popup
// itself, which has no `_storyblok_tk`) keep auto-renew.
const inStoryblokEditor = new URLSearchParams(window.location.search).has(
  "_storyblok_tk[token]"
);

export const authClient = new OktaAuth({
  issuer: CONFIG.OKTA_ISSUER,
  clientId: CONFIG.OKTA_CLIENT_ID,
  redirectUri: window.location.origin + "/login/callback",
  tokenManager: { autoRenew: !inStoryblokEditor },
});
